import styled from 'styled-components';

const Li = styled.li`
  list-style-type: disc;
`;

export const Styled = {
  Li,
};
